import validator from 'validator';
import { validatorOptions } from 'src/shared/constants/signup';

export const validateEmail = (value: string) =>
  value && !validator.isEmail(value, validatorOptions) ? 'Invalid email address' : undefined;
